var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5C7.61929 1.5 6.5 2.61929 6.5 4C6.5 4.27614 6.27614 4.5 6 4.5C5.72386 4.5 5.5 4.27614 5.5 4C5.5 2.067 7.067 0.5 9 0.5C10.933 0.5 12.5 2.067 12.5 4C12.5 4.27614 12.2761 4.5 12 4.5C11.7239 4.5 11.5 4.27614 11.5 4C11.5 2.61929 10.3807 1.5 9 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48622 4C1.87423 4 0.55039 5.2739 0.488436 6.8847L0.199084 14.4078C0.0900576 17.2425 2.3586 19.6 5.19539 19.6H12.8034C15.6402 19.6 17.9087 17.2425 17.7997 14.4078L17.5103 6.8847C17.4484 5.2739 16.1245 4 14.5126 4H3.48622ZM6.49939 8.80005C6.49939 8.52391 6.27553 8.30005 5.99939 8.30005C5.72324 8.30005 5.49939 8.52391 5.49939 8.80005C5.49939 10.733 7.06639 12.3 8.99939 12.3C10.9324 12.3 12.4994 10.733 12.4994 8.80005C12.4994 8.52391 12.2755 8.30005 11.9994 8.30005C11.7232 8.30005 11.4994 8.52391 11.4994 8.80005C11.4994 10.1808 10.3801 11.3 8.99939 11.3C7.61867 11.3 6.49939 10.1808 6.49939 8.80005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagActive);
export default __webpack_public_path__ + "static/media/bag_active.ca4d39893b4fb8e9fb74887b05eee70e.svg";
export { ForwardRef as ReactComponent };